import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type BotMigrationStats = {
  checked: number;
  migrated: number;
  skippedActive: number;
  skippedFinished: number;
  failed: number;
};

type BotMigrationResult = {
  tenantName: string;
  dryRun: boolean;
  stats: BotMigrationStats;
};

type AllCompaniesMigrationResult = {
  dryRun: boolean;
  totalCompanies: number;
  results: BotMigrationResult[];
};

export const usePreviewBotMigration = () => {
  const {
    mutateAsync,
    isPending: isLoading,
    error,
    data,
  } = useMutation<{ data: AllCompaniesMigrationResult }, Error, void>({
    mutationFn: () => api.post<AllCompaniesMigrationResult>('admin/bot-migration/preview'),
  });

  return {
    preview: async () => mutateAsync(),
    isLoading,
    error,
    result: data?.data,
  };
};

export const useExecuteBotMigration = () => {
  const {
    mutateAsync,
    isPending: isLoading,
    error,
    data,
  } = useMutation<{ data: AllCompaniesMigrationResult }, Error, void>({
    mutationFn: () => api.post<AllCompaniesMigrationResult>('admin/bot-migration/execute'),
  });

  return {
    execute: async () => mutateAsync(),
    isLoading,
    error,
    result: data?.data,
  };
};
